// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"c1aeaf70","78":"83b61907","269":"b70f6e41","335":"f6d8001a","363":"5a98e3a1","371":"2746ceda","508":"556c3ae2","526":"70fccd93","610":"812ce7cf","974":"fb923cf6"}[chunkId] + ".chunk.css";
};